module.exports = __webpack_public_path__ + "img/icon-suche.62549783.svg";